import { WgOAuth } from '../authentication/classes/WgAuthState';
import API from './classes/API';

export const ssoApi = new API({
  baseURL: process.env.REACT_APP_SSO_HOST!,
  oauthObject: WgOAuth,
});
